import configureAxios from 'configure/axios';

const axios = configureAxios();

export const find = (id) => axios.get(`bypassed/subscriptions/${id}/`);
export const fetchAll = (user_profile) => axios.get('bypassed/subscriptions/', { params: { user_profile, bypassed_status: ['active', 'suspended'] } });
export const updatePlan = (id, plan_id) => axios.post(`bypassed/subscriptions/${id}/update_plan/`, { plan_id });
export const update = (id, fields) => axios.patch(`bypassed/subscriptions/${id}/`, fields);